<template>
    <va-edit-layout>
        <SellerReviewEnrollmentPaymentEventCharge-form
            :id="id"
            :title="title"
            :item="item"
        ></SellerReviewEnrollmentPaymentEventCharge-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
